module.exports = __webpack_public_path__ + "static/media/004.49e54fc5.jpg";